import { WeekDay } from "store/types/enum";

export const getWeekDayKey = (value: WeekDay): keyof typeof WeekDay => {
  for (const key in WeekDay) {
    if (WeekDay[key as keyof typeof WeekDay] === value) {
      return key as keyof typeof WeekDay;
    }
  }
  throw new Error(`Not existing ${value} of DayWeek enum.`);
};

export const formatWeekDayToShortString = (value: WeekDay): string => {
  return getWeekDayKey(value).slice(0, 3);
};

/**
 * Helper function to transform a day in dayJs format
 * from 0 (Sunday) to 6 (Saturday) to WeekDay enum value
 */
export const dayjsDayToWeekDay = (day: number): WeekDay => {
  if (day === 0) return WeekDay.Sunday;

  return day;
};
